<button class="universal-submit-btn w-100" (click)="onPayment()" [disabled]="paymentStarted">

  <ng-container *ngIf="!paymentStarted; else Loading">Pay</ng-container>
  <ng-template #Loading class="spinner-border spinner-border-sm me-2 text-light" role="status">
    <span class="visually-hidden">Processing...</span>
  </ng-template>

</button>